import React from "react";
import "./PackManHederBack.scss";
import {useHistory} from "react-router-dom";

function PackManHederBack({title}) {

    const history = useHistory()

    return(
        <div className="header-back-container">
            <div className="header-back-row">
                <img src="/svg/back.svg" alt="" onClick={()=>{
                    history.goBack()
                }}/>
                <span>{title}</span>
            </div>
        </div>
    )
}

export {PackManHederBack}
